var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 1.10938L4.875 4.46094C4.75781 4.57812 4.61719 4.625 4.5 4.625C4.35938 4.625 4.21875 4.57812 4.10156 4.48438L0.539062 1.10938C0.304688 0.898438 0.304688 0.546875 0.515625 0.3125C0.726562 0.078125 1.07812 0.078125 1.3125 0.289062L4.5 3.28906L7.66406 0.289062C7.89844 0.078125 8.25 0.078125 8.46094 0.3125C8.67188 0.546875 8.67188 0.898438 8.4375 1.10938Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.64b3ec127b8faebf99c5f581905eb8d9.svg";
export { ForwardRef as ReactComponent };